import type { RenderSlot } from './types';

// Map resize_mode to a CSS object-fit value (mirrors VideoFrame.getMode()).
export function cssObjectFit(resizeMode: string): string {
  switch (resizeMode) {
    case 'fit':
      return 'contain';
    case 'zoom':
      return 'cover';
    case 'fill':
    default:
      return 'fill';
  }
}

// Show one element kind in a slot and hide the others.
export function showOnly(slot: RenderSlot, kind: 'video' | 'img' | 'frame'): void {
  slot.video.style.display = kind === 'video' ? 'block' : 'none';
  slot.img.style.display = kind === 'img' ? 'block' : 'none';
  slot.frame.style.display = kind === 'frame' ? 'block' : 'none';
}

// Apply volume/mute to a video honoring config + autoplay unlock state.
export function applyVideoVolume(
  video: HTMLVideoElement,
  volume: number,
  audioUnlocked: boolean,
): void {
  if (volume <= 0 || !audioUnlocked) {
    video.muted = true;
    video.volume = 0;
  } else {
    video.muted = false;
    video.volume = Math.min(1, Math.max(0, volume / 100));
  }
}
